import type { TabItem } from '../../../components/Tabs';

export type FormTabType = 'home' | 'question' | 'thanks' | 'review';

export const FORM_TABS: (TabItem & { id: FormTabType })[] = [
  { label: 'ホーム', id: 'home' },
  { label: '質問ページ設定', id: 'question' },
  { label: 'サンクスページ設定', id: 'thanks' },
  { label: '回答確認', id: 'review' },
];
